import React, { FC } from 'react';
import { Typography } from '@mui/material';
import { MeButton } from '../MeButton';

import { useStyles } from './BigidMeRequestStatusStyles';
import { e2e } from '../../utils';
import { RequestId } from '../RequestId';
import { getIcon } from '../../screens/RequestProcessingStatusRep/utils';
import { RequestStatusTypes } from '../../services';
import { UserRequestStatus } from '../../constants/userRequestStatus';
import { LanguageContainer } from '../../state/languageContainer';

export interface BigidMeManualRequestCreatedStatusPropsType {
  requestType: string;
  requestId: string;
  emailConfirmationRequired?: boolean;
}

// translation not needed BME-10200
export const BigidMeManualRequestCreatedStatus: FC<BigidMeManualRequestCreatedStatusPropsType> = ({
  requestType,
  requestId,
  emailConfirmationRequired,
}) => {
  const classes = useStyles();
  const { BigIdMeTranslate } = LanguageContainer.useContainer();

  return (
    <div className={classes.root}>
      <div className={classes.layout}>
        <div className={classes.icon}>
          {getIcon(requestType as RequestStatusTypes, UserRequestStatus.Received, BigIdMeTranslate)}
        </div>
        <div className={classes.status}>
          <Typography variant="h1" color="textSecondary" {...e2e('request_status_title')}>
            Request Created
          </Typography>
        </div>
        {emailConfirmationRequired && (
          <div className={classes.text}>
            <Typography variant="subtitle1" color="textPrimary" {...e2e('request_status_description')}>
              Confirmation email sent to the requestor
            </Typography>
          </div>
        )}
        <RequestId requestId={requestId} />
        <div className={classes.button}>
          <MeButton
            onClick={() => window.location.reload()}
            text="Submit another request"
            type="primary"
            {...e2e('submit_another_request-button')}
            bi={{ eventType: 'request_status_submit_another_request' }}
          />
        </div>
      </div>
    </div>
  );
};
